var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClosebgicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F9FAFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5017 13.7472C25.3274 13.5724 25.0906 13.4742 24.8437 13.4742C24.5969 13.4742 24.3601 13.5724 24.1857 13.7472L19.6217 18.3018L15.0577 13.7378C14.8834 13.5631 14.6466 13.4648 14.3997 13.4648C14.1529 13.4648 13.9161 13.5631 13.7417 13.7378C13.3778 14.1018 13.3778 14.6898 13.7417 15.0538L18.3057 19.6178L13.7417 24.1818C13.3778 24.5458 13.3778 25.1338 13.7417 25.4978C14.1057 25.8618 14.6937 25.8618 15.0577 25.4978L19.6217 20.9338L24.1857 25.4978C24.5497 25.8618 25.1377 25.8618 25.5017 25.4978C25.8657 25.1338 25.8657 24.5458 25.5017 24.1818L20.9377 19.6178L25.5017 15.0538C25.8564 14.6992 25.8564 14.1018 25.5017 13.7472Z",
    fill: "#6B7280"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosebgicon);
export default __webpack_public_path__ + "static/media/closebgicon.43a62f927fb1441ee9da07e5b9925999.svg";
export { ForwardRef as ReactComponent };